/* eslint-disable camelcase */
import React from 'react';
import {
  Link,
} from 'react-router-dom';
import {
  Formik,
  Field,
} from 'formik';
import * as Yup from 'yup';

import {
  Flex,
  Text,
  icons,
} from 'web-styled';
import {
  Button,
  TextField,
  PasswordField,
  CheckboxField,
  SetNamespace,
} from 'web-components';

import * as S from '../styled';

const validationSchema = Yup.object().shape({
  email: Yup.string()
    .email('Email must be a valid email')
    .required('Email is required'),
  password: Yup.string()
    .min(6)
    .required('Password is required'),
  password_confirmation: Yup.string()
    .required('Confirm password is required')
    .oneOf([Yup.ref('password'), null], 'Passwords do not match'),
  agreement: Yup.bool()
    .oneOf([true], 'Must Accept Terms and Privacy Policy')
    .required('is required'),
});

interface Props {
  params: {
    email?: string;
    first_name?: string;
  },
  onSubmit: { (data: any, actions: any): void },
}

const ClientForm = ({
  params,
  onSubmit,
}: Props) => (
  <S.ClientContainer>
    <Flex
      column
      spacing={45}
      width="600px"
    >
      <Flex column spacing={5}>
        <Text
          size="18px"
          color="#fff"
          family="avenir"
          lineHeight="24px"
        >
          {`Hey ${params?.first_name},`}
        </Text>
        <Text
          size="18px"
          color="#fff"
          family="avenir"
          lineHeight="24px"
        >
          We&apos;ll use GymCloud to share workouts, track performance,
          and communicate.
        </Text>
        <Text
          size="18px"
          color="#fff"
          family="avenir"
          lineHeight="24px"
        >
          Let&apos;s get your training account set up.
        </Text>
        <Text
          size="18px"
          color="#fff"
          family="avenir"
          lineHeight="24px"
        >
          Enter your email address, create a password, read and accept
          Terms and Privacy Policy, and click &quot;Continue&quot;.
        </Text>
      </Flex>
      <Formik
        initialValues={{
          email: params?.email,
          password: '',
          password_confirmation: '',
          agreement: false,
        }}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        {(formikProps) => (
          <S.Form
            column
            spacing={30}
            onSubmit={formikProps.handleSubmit}
          >
            <S.FormLogo>
              <img src={icons.logo} alt="" />
            </S.FormLogo>
            <Flex column width="100%" spacing={15}>
              <Field
                name="email"
                label="Email"
                component={TextField}
                type="text"
                disabled
                placeholder="your@email.com"
              />
              <Field
                name="password"
                label="Password"
                component={PasswordField}
                placeholder="Set a password"
              />
              <Field
                name="password_confirmation"
                label="Confirm Password"
                component={PasswordField}
                placeholder="Set a password"
              />
              <Field
                name="agreement"
                label={(
                  <span>
                    {'I Accept the '}
                    <a
                      href="https://www.gymcloud.com/legal/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      GymCloud Terms and Privacy Policy
                    </a>
                  </span>
                )}
                justify="center"
                className="agreement"
                component={CheckboxField}
              />
              <Flex
                width="100%"
                justify="space-between"
                align="center"
              >
                <Button
                  fit
                  type="submit"
                  spacing="big"
                  borderRadius="5px"
                  isDisabled={(!formikProps.isValid || formikProps.isSubmitting)}
                  isLoading={formikProps.isSubmitting}
                  appearance="primaryBright"
                >
                  Accept Invite and Continue
                </Button>
              </Flex>
              <Flex width="100%" justify="center">
                <div>
                  Already have an account?
                  {' '}
                  <Link to="/login">Sign in</Link>
                </div>
              </Flex>

              {process.env.TARGET_ENV !== 'production' && (
                <Flex width="100%" justify="center">
                  <SetNamespace />
                </Flex>
              )}
            </Flex>
          </S.Form>
        )}
      </Formik>
    </Flex>
  </S.ClientContainer>
);

export default ClientForm;
